<template>
  <section>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      :can-cancel="false"
    >
      <form v-on:submit.prevent="saveAnswer">
        <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <header class="modal-card-head">
            <p class="modal-card-title">Encuesta</p>
          </header>
          <section class="modal-card-body">
            <h1 class="title is-4" style="display: flex;
    flex-direction: row;">
              <img src="\images\Logo-SSM.jpg" width="90"/>
              <div style="margin-left: 1em">Nombre de la Encuesta: {{Questionarie.name}}</div>
            </h1>

            <h2 class="content" v-html="Questionarie.description"></h2>
            <div class="box" v-for="(Question, index) in Questions" :key="Question.id">
         
              <div v-if="Question.id==24">
                <b>TRATO DE ATENCIÓN USUARIO.</b><br>
                Evalúe la atención y el grado de satisfacción de acuerdo a las aﬁrmaciones en una escala de 1 a 5.<br><br>
                1: Muy Mala<br>
                2: Mala<br>
                3: Ni muy mala, ni muy buena<br>
                4: Buena<br>
                5: Muy Buena<br><br>
              </div>
              <div v-if="Question.id==29">
                <b>ATENCIÓN CLÍNICA-SATISFACCIÓN.</b><br>
                Evalúe la atención y el grado de satisfacción de acuerdo a las aﬁrmaciones en una escala de 1 a 5.<br><br>
                1: Muy Mala<br>
                2: Mala<br>
                3: Ni muy mala, ni muy buena<br>
                4: Buena<br>
                5: Muy Buena<br><br>
              </div>
              <div v-if="Question.id==32">
                <b>INFRAESTRUCTURA Y PERCEPCIÓN DEL CENTRO.</b><br>
                Evalúe la atención y el grado de satisfacciones de acuerdo a las aﬁrmación en una escala de 1 a 5.<br><br>
                1: Muy Mala<br>
                2: Mala<br>
                3: Ni muy mala, ni muy buena<br>
                4: Buena<br>
                5: Muy Buena<br><br>
              </div>
              <div class="content" >
              <strong>{{ index + 1 }}.- </strong>
                <span v-html="Question.question"></span>
              </div>
              <ul v-if="Question.type_selection_id == 1">
                <b-field
                  v-for="Answer in Question.questions_alternatives"
                  :key="Answer.alternative.id"
                >
                  <b-radio
                    v-show="Answer.alternative.alternative != 'En Blanco'"
                    v-model="Question.id_answer"
                    :native-value="Answer.alternative.id"
                    >{{ Answer.alternative.alternative }}
                  </b-radio>
                  <b-input
      v-if="Answer.alternative.alternative.toLowerCase() === 'otro' && Question.id_answer === Answer.alternative.id&& index + 1 ===2
      || Answer.alternative.alternative.toLowerCase() === 'otro' && Question.id_answer === Answer.alternative.id&& index + 1 ===5 
      || Answer.alternative.alternative.toLowerCase() === 'otro' && Question.id_answer === Answer.alternative.id&& index + 1 ===8"
      v-model="Question.other_answer"
      placeholder="Especifique..."
      style="margin-left: 1.5em; margin-top: 0.5em; width: 50%;"
    ></b-input>
                </b-field>
              </ul>
              <div v-else class="block" style="margin-top: 1em">
                  <b-field
                    v-for="answer in Question.questions_alternatives"
                    :key="answer.alternative.id"
                  >
                    <b-checkbox
                      v-show="answer.alternative.alternative != 'En Blanco'"
                      :native-value="answer.alternative.id"
                      v-model="Question.answers"
                    >
                      {{ answer.alternative.alternative }}
                    </b-checkbox>

                    <!-- Campo de texto cuando selecciona "Otro" -->
                    <b-input
  v-if="
    answer.alternative.alternative.toLowerCase() === 'otro' &&
    Question.answers.includes(answer.alternative.id)
  "
  v-model="Question.other_answers[answer.alternative.id]"
  placeholder="Especifique..."
  style="margin-left: 1.5em; margin-top: 0.5em; width: 50%;"
/>

                  </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="closeBasic()">
              Cerrar
            </button>
            <button class="button is-primary" type="submit">Responder encuesta</button>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>
<script>
import { getQuestionariePublic } from "../../services/questionarie";
import { storeAnswerPublic } from "../../services/answer";
import { storeUserQuestionariePublic } from "../../services/users_questionaries";

// import {
//   deleteQuestion,
//   editQuestion,
//   getQuestion,
// } from "../../services/question";

export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "questionarie_id",
    "chargeQuestionarieList",
  ],
  data() {
    return {
      isLoading: false,
      Questionarie: {
        name: "",
        description: "",
      },
      radio: "",
      Questions: [],
      test: [],
    };
  },
  created: function () {
    this.isLoading = true;
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.Questions = [];
      await getQuestionariePublic(this.$http, this.questionarie_id).then(
        (response) => {
          console.log("DATA:", response);
          this.Questionarie = response;
          response.questions.forEach((question) => {
            this.Questions.push({
  ...question,
  answers: [],
  id_answer: question.questions_alternatives.find(
    (element) => element.alternative.alternative == "En Blanco"
  ).alternative.id,
  other_answers: {}, // 👈 un objeto donde guardaremos los textos "Otro" por ID
});

          });
          this.isLoading = false;
        }
      );
    },
    async saveAnswer() {
      let withoutAnswer = false;
      for (let i = 0; i < this.Questions.length; i++) {
        const question = this.Questions[i];
        if (question.type_selection_id == 1) {
          if (!question.id_answer) {
            withoutAnswer = true;
          }
        } else {
          if (question.answers.length == 0) {
            // withoutAnswer = true;
            let alternativeId = question.questions_alternatives.find(
                (element) => element.alternative.alternative == "En Blanco"
              ).alternative.id;
            this.Questions[i].answers.push(alternativeId);
          }
          if (question.answers.length > 6) {
            this.$buefy.dialog.alert({
              title: "Falla de validación",
              message: `La pregunta ${question.question} solo permite seleccionar <b>6 opciones como máximo</b>, actualmente hay seleccionadas ${question.answers.length }`,
              type: "is-warning",
              hasIcon: true,
            });
            return;
          }
        }
      }

      if (!withoutAnswer) {
        this.isLoading = true;
        let data = {
          questionary_id: this.questionarie_id,
          user_id: 341,
          state: "Realizado",
        };
        await storeUserQuestionariePublic(this.$http, data).then((response) => {
          var id_user_questionarie = response.id;
          let promises = [];
          this.Questions.forEach(async (question) => {
            if (question.type_selection_id == 1) {
              promises.push(
                new Promise((resolve, reject) => {
                let data = {
                  user_questionary_id: id_user_questionarie,
                  alternative_id: question.id_answer,
                  state: "Respondido",
                  other_answer: question.other_answer || null, // 👈 nuevo campo
                };
                  storeAnswerPublic(this.$http, data)
                    .then(() => {
                      resolve();
                    })
                    .catch(() => {
                      reject();
                    });
                })
              );
            } else {
            for (let i = 0; i < question.answers.length; i++) {
  const answer = question.answers[i];
  promises.push(
    new Promise((resolve, reject) => {
      let data = {
        user_questionary_id: id_user_questionarie,
        alternative_id: answer,
        state: "Respondido",
        other_answer: question.other_answers[answer] || null, // 👈 solo si esa alternativa lo tiene
      };
      storeAnswerPublic(this.$http, data)
        .then(() => resolve())
        .catch(() => reject());
    })
  );
}

            }
          });
          Promise.all(promises).then(() => {
            this.isLoading = false;
            this.chargeQuestionarieList();
            this.$buefy.dialog.alert({
              title: "Exito",
              message:
                  "La encuesta ha sido respondida con éxito.",
              type: "is-success",
              hasIcon: true,
              ariaRole: "alertdialog",
              ariaModal: true,
            });
            this.closeBasic();
          });
        });
      } else {
        this.$buefy.dialog.alert({
          title: "Falla de validación",
          message: "Hay una o más preguntas sin respuesta.",
          type: "is-warning",
          hasIcon: true,
        });
      }
    },
  },
};
</script>